module.exports = __webpack_public_path__ + "static/Banner-68e6116d21c2376e85041a252e23ee3d.png";